import "shared/extensions/date";

import { UpdateUserCommand, useUpdateUserFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { NoValueSelected } from "shared/constants/SelectConstants";
import PersonalInfoForm, { Inputs, toPhoneFields } from "../Components/PersonalInfoForm/PersonalInfoForm";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useUserContext } from "core/state/UserContext/UserContext";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { trackFormSubmission } from "core/monitoring/Events";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import ClientLogoImage from "shared/UI/ClientLogo/ClientLogoImage";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

export const PersonalDetails = () => {
  const { modalNotify } = useNotifyModalContext();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState(false);
  const { trigger } = useUpdateUserFunctionRequest({});
  const { user, saveUser } = useUserContext();
  const client = user?.client;

  const onSubmit = async (inputs: Inputs, reset: any, getValues: any) => {
    setErrorMessage(false);
    const fullData: UpdateUserCommand = {
      dateOfBirth: inputs.dateOfBirth.toDateOnly(),
      gender: inputs.gender,
      forenames: inputs?.forenames,
      surname: inputs?.surname,
      divisionId: inputs.divisionId === NoValueSelected ? undefined : inputs.divisionId,
      ...toPhoneFields(inputs.phone),
    };
    trackFormSubmission("Personal-Details");
    try {
      const response = await trigger({ body: fullData });
      saveUser(response!.data);
      modalNotify("success", t("personalDetails.requestSuccessMessage"));
    } catch {
      setErrorMessage(true);
    }
  };

  return (
    <>
      <PageTitle title={t("pageTitle.account.personalDetails")} />
      <PageHeader narrowView hideForMobile hideBackForDesktop />
      <NarrowContainer>
        <div data-testid="details" className="mb-6 space-y-2 text-center">
          {client && client.logoUrl && (
            <div className={"flex justify-center items-center"}>
              <div>
                <ClientLogoImage
                  className="h-10 object-contain"
                  clientCode={client?.code}
                  imageFilename={client.logoUrl}
                  alt={t("personalDetails.clientLogoAltText")}
                />
              </div>
            </div>
          )}
          <p className="font-bold">{user?.email}</p>
          <p>
            {t("personalDetails.orgCodeTitle")} <span className="font-bold">{user?.client?.code}</span>
          </p>
        </div>
        <PersonalInfoForm user={user} onSubmit={onSubmit} errorMessage={errorMessage} type="personalDetails" />
      </NarrowContainer>
    </>
  );
};
